import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { HardHat } from "lucide-react";
import { btnPrimary, inputCls, Field } from "../components/Modal";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) navigate(r.user?.platform_role === "superadmin" ? "/admin" : "/");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden lg:block lg:w-1/2 relative">
        <img src="https://images.unsplash.com/photo-1759200165738-6366977a73c6?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Quincaillerie" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/70 flex flex-col justify-end p-12">
          <h1 className="font-heading text-4xl font-extrabold text-white leading-tight">La gestion commerciale<br />de votre quincaillerie.</h1>
          <p className="text-slate-300 mt-4 max-w-md">Stock, caisse, achats, crédits, dépenses et rapports — une plateforme unique, vos données 100% privées.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm space-y-5">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-accent flex items-center justify-center"><HardHat className="h-6 w-6 text-accent-foreground" /></div>
            <div>
              <div className="font-heading font-extrabold text-xl">QuincailleriePro</div>
              <div className="text-xs text-muted-foreground">Plateforme SaaS multi-quincailleries</div>
            </div>
          </div>
          <h2 className="font-heading text-2xl font-bold">Connexion</h2>
          {error && <div data-testid="login-error" className="p-3 rounded-lg bg-rose-50 text-rose-700 dark:bg-rose-950 dark:text-rose-300 text-sm font-medium">{error}</div>}
          <Field label="Email">
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="vous@quincaillerie.com" />
          </Field>
          <Field label="Mot de passe">
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </Field>
          <button data-testid="login-submit" disabled={loading} className={`${btnPrimary} w-full h-11`}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
          <div className="flex items-center justify-between text-sm">
            <Link to="/mot-de-passe-oublie" data-testid="forgot-password-link" className="text-primary font-semibold hover:underline">Mot de passe oublié ?</Link>
          </div>
          <p className="text-xs text-muted-foreground text-center">La création d'une quincaillerie est gérée par l'administrateur de la plateforme.</p>
        </form>
      </div>
    </div>
  );
}
